import {createReducer} from 'redux-act';
import {
  FORM_CHANGED,
  SHOW_EMAIL_CHECK_MODAL,
  OPEN_CANCELLATION_CONFIRMATION_MODAL,
  SET_LOADING_CANCELLATION,
  OPEN_CANCELLATION_CONFIRMATION_MODAL_V2,
  SET_LOADING_CANCELLATION_V2
} from './action';

const initialState = () => ({
  isFormChanged: false,
  isEmailCheckModalOpen: false,
  isOpenCancellationModal: false,
  orderCancellationSource: null,
  orderCancellationInfo: null,
  orderCancellationDeliveryProvider: null,
  loadingCancellation: false,
  isOpenCancellationModalV2: false,
  orderCancellationSourceV2: null,
  orderCancellationInfoV2: null,
  orderCancellationDeliveryProviderV2: null,
  loadingCancellationV2: false
});

const modalsReducer = createReducer(
  {
    [FORM_CHANGED]: (state, {changed}) => ({
      ...state,
      isFormChanged: changed
    }),
    [SHOW_EMAIL_CHECK_MODAL]: (state, payload) => ({
      ...state,
      isEmailCheckModalOpen: Boolean(payload)
    }),
    [OPEN_CANCELLATION_CONFIRMATION_MODAL]: (state, payload) => {
      return {
        ...state,
        isOpenCancellationModal: payload.isOpen,
        orderCancellationInfo: payload.info,
        orderCancellationSource: payload.source,
        orderCancellationDeliveryProvider: payload.deliveryProvider
      };
    },
    [SET_LOADING_CANCELLATION]: (state, payload) => {
      return {
        ...state,
        loadingCancellation: payload
      };
    },
    [OPEN_CANCELLATION_CONFIRMATION_MODAL_V2]: (state, payload) => {
      return {
        ...state,
        isOpenCancellationModalV2: payload.isOpen,
        orderCancellationInfoV2: payload.info,
        orderCancellationSourceV2: payload.source,
        orderCancellationDeliveryProviderV2: payload.deliveryProvider
      };
    },
    [SET_LOADING_CANCELLATION_V2]: (state, payload) => {
      return {
        ...state,
        loadingCancellationV2: payload
      };
    }
  },
  initialState()
);

export default modalsReducer;
